import { themeLight, themeDark } from "../constants";

type ResolvedTheme = typeof themeLight | typeof themeDark;

/**
 * Returns a placeholder image URL based on the current theme.
 *
 * @param theme - The resolved theme ("light" or "dark")
 * @returns The placeholder image URL for the given theme
 */
export function getPlaceholderImage(theme: ResolvedTheme = themeLight): string {
  if (theme === themeDark) {
    return "/placeholder-dark.png";
  }
  return "/placeholder-light.png";
}
